<h1 class="center">Répartition par lingerie de la livraison du
	{{ commandeDetails?.date_livraison | date: 'EEEE': 'fr'}}
	{{ commandeDetails?.date_livraison | date: 'dd/MM/yyyy': 'fr'}}</h1>
<nav>
	<a class="tabs-orders" [ngClass]="selected=='reception' ? 'tabs-orders-selected' : ''"
		routerLinkActive="active-link" (click)="changeTab('reception')">Réception</a>
	<a class="tabs-orders" [ngClass]="selected=='dispatch' ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="changeTab('dispatch')">Dispatch</a>
	<a class="tabs-orders" [ngClass]="selected=='distribution' ? 'tabs-orders-selected' : ''"
		routerLinkActive="active-link" (click)="changeTab('distribution')">Distribution</a>
</nav>
<div class="container" *ngIf="selected == 'reception'">
	<div class="flex justify-center">
		<mat-spinner *ngIf="loading || !commandeDetails"></mat-spinner>
	</div>
	<div class="flex flex-col items-center" *ngIf="!loading && commandeDetails">
		<div class="clamp-besoin">
			<table class="styled-table">
				<thead>
					<tr>
						<th>Article</th>
						<th>
							<div class="icon-custom">Bon de livraison
								<mat-icon (click)="modify()" class="icon-click" *ngIf="!isReceptionUpdate && !readonly"
									matTooltip="Modifier les quantités réceptionnées"
									matTooltipPosition="right">create</mat-icon>
							</div>
						</th>
						<th *ngIf="isReceptionUpdate">Quantité réceptionnée</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let data of commandeDetails.lod_ligne_commandes">
						<td>{{ data.article.designation }}</td>
						<td [ngClass]="{'large' : !isReceptionUpdate}">{{ data.qte_livree }}</td>
						<td *ngIf="isReceptionUpdate">
							<mat-form-field>
								<mat-label></mat-label>
								<input type="number" matInput [value]="data.qte_reception" min=0
									(change)="updateReception(data, $event)" #txtInput (keydown.enter)="txtInput.blur()"
									[disabled]="readonly || disabledUpdate">
							</mat-form-field>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="isReceptionUpdate">
			<mat-form-field>
				<mat-label>Commentaire (Réclamation)</mat-label>
				<textarea matInput rows="7" cols="70" placeholder="Saisir un commentaire"
					[formControl]="commentaire"></textarea>
			</mat-form-field>
		</div>
	</div>
	<div class="buttons-center">
		<button mat-raised-button (click)="refuse()" color="white">Retour</button>
		<button mat-raised-button type="button" (click)="saveReception()" *ngIf="isReceptionUpdate"
			[disabled]="isSaving || readonly || disabledUpdate">Enregistrer</button>
	</div>
</div>
<div class="container" *ngIf="selected == 'dispatch'">
	<div class="flex justify-center">
		<mat-spinner *ngIf="loading"></mat-spinner>
	</div>
	<div class="flex justify-center mt-5" *ngIf="!loading">
		<div class="clamp-besoin">
			<div class="header">
				<div>Article</div>
				<div>Besoin</div>
				<div>Dispatch / Réception</div>
				<div></div>
			</div>
			<mat-tree [dataSource]="dataSourceR" [treeControl]="treeControl" class="example-tree">
				<mat-nested-tree-node *matTreeNodeDef="let article">
					<div *ngIf="article.inventaires.length > 0">
						<div class="mat-tree-node node-flex">
							<button type="button" mat-icon-button matTreeNodeToggle
								[attr.aria-label]="'Toggle ' + article.article.id">
								<mat-icon class="mat-icon-rtl-mirror">
									{{treeControl.isExpanded(article) ? 'expand_more' : 'chevron_right'}}
								</mat-icon>
							</button>
							<div>{{article.article.designation}}</div>
							<div>{{article.quantite}}</div>
							<div>{{getSommeInventaireArticle(article)}} / {{article.qte_reception ??
								article.qte_livree}}</div>
							<div>
								<mat-icon *ngIf="getSommeInventaireArticle(article) == getQuantiteComparaison(article)"
									color="primary">check_circle</mat-icon>
								<mat-icon
									*ngIf="!article?.isDispatchAuto && getSommeInventaireArticle(article) != getQuantiteComparaison(article)"
									color="red">cancel</mat-icon>
								<mat-icon
									*ngIf="article?.isDispatchAuto && getSommeInventaireArticle(article) != getQuantiteComparaison(article)"
									matTooltip="Les arrondis empêchant un dispatch automatique parfait, nous vous laissons répartir manuellement les quantités incorrectes."
									class="warning">warning</mat-icon>
							</div>
						</div>
						<div [class.example-tree-invisible]="!treeControl.isExpanded(article)" class="content-node">
							<button mat-raised-button type="button" (click)="dispatchAuto(article)"
								class="mt-2.5 mr-auto" [disabled]="article?.isDispatchAuto || readonly">
								<mat-icon>update</mat-icon> Dispatch automatique
							</button>
							<table class="styled-table">
								<thead>
									<tr>
										<th>Lingerie</th>
										<th>Besoin</th>
										<th>Dispatch</th>
										<th *ngIf="currentClient.enabled_complement">Complement</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let ligne of article.inventaires">
										<td>{{ligne.lingerie.libelle}}</td>
										<td>{{ligne.commande}}</td>
										<td>
											<mat-form-field>
												<mat-label></mat-label>
												<input type="number" matInput #commande [value]="ligne.qte_dispatch"
													min=0 max="article.qte_livree"
													(change)="updateInventaire(article, ligne, $event)" #txtInput
													(keydown.enter)="txtInput.blur()" [disabled]="readonly">
											</mat-form-field>
										</td>
										<td *ngIf="currentClient.enabled_complement">
											<mat-form-field>
												<mat-label></mat-label>
												<input type="number" matInput #commande [value]="ligne.qte_complement"
													min=0 max="ligne.dotation"
													(change)="updateComplement(ligne, $event)" #txtInput
													(keydown.enter)="txtInput.blur()" [disabled]="readonly">
											</mat-form-field>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</mat-nested-tree-node>
			</mat-tree>
		</div>
	</div>
	<div class="buttons-center">
		<button mat-raised-button (click)="refuse()" color="white">Retour</button>
		<button mat-raised-button type="button" (click)="saveDispatch()"
			[disabled]="isSaving || readonly">Enregistrer</button>
	</div>
</div>
<div class="container" *ngIf="selected == 'distribution'">
	<div class="flex justify-center">
		<mat-spinner *ngIf="loading"></mat-spinner>
	</div>
	<div class="flex justify-center mt-5" *ngIf="!loading">
		<div class="clamp-besoin">
			<mat-tree [dataSource]="dataSourceL" [treeControl]="treeControl2" class="example-tree">
				<mat-nested-tree-node *matTreeNodeDef="let inventaire">
					<div *ngIf="inventaire.inventaire_lignes.length > 0">
						<div class="mat-tree-node">
							<button type="button" mat-icon-button matTreeNodeToggle
								[attr.aria-label]="'Toggle ' + inventaire.lingerie.id">
								<mat-icon class="mat-icon-rtl-mirror">
									{{treeControl2.isExpanded(inventaire) ? 'expand_more' : 'chevron_right'}}
								</mat-icon>
							</button>
							<div>{{inventaire.lingerie.libelle}}</div>
						</div>
						<div [class.example-tree-invisible]="!treeControl2.isExpanded(inventaire)" class="content-node">
							<table class="styled-table">
								<thead>
									<tr>
										<th>Article</th>
										<th>Besoin</th>
										<th>Dispatch</th>
										<th *ngIf="currentClient.enabled_complement">Complement</th>
										<th *ngIf="currentClient.enabled_complement">Distribution</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let ligne of inventaire.inventaire_lignes">
										<td>{{ ligne.article.designation }}</td>
										<td>{{ ligne.qte_commande }}</td>
										<td>{{ ligne.qte_dispatch }}</td>
										<td *ngIf="currentClient.enabled_complement">{{ ligne.qte_complement }}</td>
										<td *ngIf="currentClient.enabled_complement">{{ ligne.qte_livree ??
											ligne.qte_dispatch }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</mat-nested-tree-node>
			</mat-tree>
		</div>
	</div>
	<div class="buttons-center">
		<button mat-raised-button (click)="refuse()" color="white">Retour</button>
	</div>
</div>